import styled from 'styled-components';

import { body, heading } from '@constants/fonts';

import tipWave from '@images/tip-wave.svg';

export const TipCardDiv = styled.div`
  background:
    url(${tipWave}),
    linear-gradient(
      135deg,
      ${({ theme }) => theme.palette.gradient.light} 0%,
      ${({ theme }) => theme.palette.gradient.dark} 100%
    );
  background-size: 100% 100%;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 8px;
  padding: 20px 16px 18px 16px;
  box-shadow: ${({ theme }) => theme.shadows[24]};
  cursor: pointer;
  transition: box-shadow 0.3s;
  width: 310px;
  min-height: 185px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows[24]};
  }

  p {
    opacity: 0.7;
    color: ${({ theme }) => theme.palette.primary.contrastText};
    font-family: ${body};
    font-size: 14px;
    font-weight: 600;
    margin: 0;
  }

  h2 {
    font-size: 32px;
    line-height: 40px;
    color: ${({ theme }) => theme.palette.primary.contrastText};
    font-family: ${heading};
    font-weight: 600;
    margin: 6px 0;
  }
`;
